import React from "react";

const TotalsBar = ({ totalAchatsCount, totalAchats }) => {
  return (
    <div className="px-5 pb-4 sm:px-8">
      <div className="mt-1 flex items-center gap-4 text-sm text-slate-700 dark:text-slate-300">
        <span className="inline-flex items-center rounded-lg bg-slate-100 dark:bg-slate-800 px-3 py-1">
          <span className="mr-2 opacity-70">Total achats</span>
          <span className="font-semibold">{totalAchatsCount}</span>
        </span>
        <span className="inline-flex items-center rounded-lg bg-slate-100 dark:bg-slate-800 px-3 py-1">
          <span className="mr-2 opacity-70">Somme</span>
          <span className="font-semibold">{totalAchats} €</span>
        </span>
      </div>
    </div>
  );
};

export default TotalsBar;
